// importing it directly from react-query cause we don't want to follow the query key rule that we have in our useQuery hook
import { useQuery } from '@tanstack/react-query'

import { Poll } from '@tribeplatform/gql-client/types'

import { getPollKey } from '../../utils/keys/poll.key.js'

export const usePoll = (id: Poll['id']) => {
  const { data } = useQuery<Poll>(
    getPollKey(id),
    () => {
      return undefined // we always wanted to read cached data
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      keepPreviousData: true,
      networkMode: 'offlineFirst',
      enabled: false,
    },
  )

  return data
}
